import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";
import "./App.css";
import HomeDashboard from "./HomeDashboard";
import HomePage from "./HomePage";
import MarketInsight from "./MarketInsight";
import Leaderboard from "./Leaderboard";
import Feedback from "./Feedback";
import Menu from "./Menu";
import Login from "./Login";
import Footer from "./Footer";
import Profile from "./Profile";


import { useLocation } from "react-router-dom";

const AppLayout = () => {
  const location = useLocation();
  const hideFooter = location.pathname === "/";
  return (
    <div className="app-wrapper">
      <main className="page-content">
        <Outlet />
      </main>
      {!hideFooter && <Footer />}
    </div>
  );
};


function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return !!localStorage.getItem("userToken");
  });
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstall, setShowInstall] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstall(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleLogin = () => {
    localStorage.setItem("userToken", "1"); 
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("userToken");
    setIsLoggedIn(false);
  };

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        setShowInstall(false);
      }
      setDeferredPrompt(null);
    }
  };

  return (
    <>
      {showInstall && (
        <div style={{position: 'fixed', bottom: 20, left: 0, right: 0, zIndex: 9999, display: 'flex', justifyContent: 'center'}}>
          <div style={{background: '#fff', border: '1px solid #ccc', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.15)'}}>
            <span style={{marginRight: 12}}>Install this app for a better experience!</span>
            <button onClick={handleInstallClick} style={{padding: '6px 16px', borderRadius: 4, background: '#1976d2', color: '#fff', border: 'none'}}>Install</button>
          </div>
        </div>
      )}
      <Router>
        <Routes>
          <Route
            path="/login"
            element={
              isLoggedIn ? <Navigate to="/" /> : <Login onLogin={handleLogin} />
            }
          />
          <Route
            path="/"
            element={isLoggedIn ? <AppLayout /> : <Navigate to="/login" />}
          >
            <Route index element={<HomeDashboard />} />
            <Route path="insight" element={<MarketInsight />} />
            <Route path="leaderboard" element={<Leaderboard />} />
            <Route path="feedback" element={<Feedback />} />
            <Route path="menu" element={<Menu onLogout={handleLogout} />} />
            <Route path="profile" element={<HomePage />} />
          </Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
